import { useAtomValue } from 'jotai';

import { Stack } from '@ekhodealer/ekho-common/rev';

import { AccordionSection } from '@common/components/AccordionSection';
import { InfoLineItem } from '@common/components/InfoLineItem';

import { useGetOrderDetails } from '../../api/useGetOrderDetails';
import { orderDetailsDrawerAtom } from '../../atoms/orderDetailsDrawerAtoms';

import { SectionSkeleton } from './shared/SectionSkeleton';

const SECTION_TITLE = 'Reference';

export const ReferenceSection = () => {
	const { selectedRow } = useAtomValue(orderDetailsDrawerAtom);
	const { data: orderDetails, isLoading } = useGetOrderDetails(
		selectedRow?.purchasedVehicleId || undefined,
	);

	if (isLoading) {
		return <SectionSkeleton title={SECTION_TITLE} />;
	}

	if (!orderDetails) {
		return null;
	}

	const { reference } = orderDetails;

	return (
		<AccordionSection title={SECTION_TITLE} defaultExpanded>
			<Stack itemsSpacing='16'>
				{reference.programName && (
					<InfoLineItem title='Program' value={reference.programName} />
				)}
				{reference.sellerName && (
					<InfoLineItem title='Seller' value={reference.sellerName} />
				)}
				<InfoLineItem
					title='Order number'
					value={
						reference.orderNumber
							? `#${reference.orderNumber}`
							: reference.orderId?.substring(0, 8)
					}
					isCopyable
				/>
				<InfoLineItem title='Order ID' value={reference.orderId} isCopyable />
				<InfoLineItem
					title='Purchased vehicle ID'
					value={reference.purchasedVehicleId}
					isCopyable
				/>
				<InfoLineItem title='Buyer name' value={reference.buyerName} isCopyable />
			</Stack>
		</AccordionSection>
	);
};
